import { Box, Typography } from "@mui/material";
import { QuotaProgressBar } from "./QuotaProgressBar";
import { useSelectedClient } from "../../../../../Queries/ClientQueries";

export const ClientQuotaSection = () => {
  const { data: selectedClient } = useSelectedClient();
  return (
    <Box
      sx={(theme) => ({
        padding: 1,
        background: theme.colors.primary.fadeBlack_Light,
      })}
    >
      <Box>
        <Typography sx={{ fontWeight: "normal", padding: 0.5 }}>Emails:</Typography>
        <QuotaProgressBar
          currentValue={selectedClient?.sentEmailCount || 0}
          quota={selectedClient?.quotas?.emailQuota || 0}
          id="emailQuota"
        />
      </Box>
      <Typography sx={{ fontWeight: "normal", padding: 0.5 }}>Texts:</Typography>
      <QuotaProgressBar
        currentValue={selectedClient?.sentTextCount ?? 0}
        quota={selectedClient?.quotas?.textQuota ?? 0}
        id="textQuota"
      />
    </Box>
  );
};
